import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { StatusViewModel } from '../../../business-entities/status-view-model';
import { DashboardService } from '../../../business-services/dashboard.service';
import { AddCompetenceComponent } from '../add-competence/add-competence.component';
import { EditCompetenceComponent } from '../edit-competence/edit-competence.component';
import * as Enums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { CompetenceListViewModel } from './../../../business-entities/competenceList-view-model';
import { UserRoleMenu } from './../../../business-entities/user-role-menu.model';
import { CompetenceBusinessService } from './../../../business-services/competence.service';

@Component({
  selector: 'app-competence',
  templateUrl: './competence.component.html'
})
export class CompetenceComponent implements OnInit {

  paginationSub: Subscription;
  userRoleRightsDetails: UserRoleMenu;
  competenceListViewModel: CompetenceListViewModel[];
  total$: Observable<number>;
  popupCloseResult = false;
  StatusList:StatusViewModel[] = [];
  selectedStatus: number;
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(
    private competenceService: CompetenceBusinessService,
    public pService: CustomPaggerService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private userService: UserDataService,
    private modalService: NgbModal,
    private dashboardService: DashboardService,
    config: NgbModalConfig
    ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['name','code','priority','brands','isActive'];
    this.pService.searchTerm = '';
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    let status = 0;
    if(this.selectedStatus != undefined){
      status = this.selectedStatus;
    }
    this.StatusList = this.dashboardService.getStatusList();
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.competence);
    this.pService.dataSource = [];
    this.getCompetence(status);
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  onAdd() {
    const modalref = this.modalService.open(AddCompetenceComponent, { size: 'lg', windowClass: 'EditPopup' });
      modalref.result.then((res) => {
        if (res.success) {
          this.ngOnInit();
        }
      });
  }

  gotoEdit(id: any) {
      this.competenceService.competenceId = id;
      const modalref = this.modalService.open(EditCompetenceComponent, { size: 'lg', windowClass: 'EditPopup' });
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
      });
  }

  StatusChange(status: Enums.StatusCode){
    if(status == undefined){
      status = Enums.StatusCode.All;
    }
    this.getCompetence(status);
  }

  getCompetence(status:number) {
    this.spinner.show();
    this.competenceListViewModel = [];
    this.competenceService.getCompetence(status).then((response) => {
      if (response.responseCode == Constant.SuccessResponseCode &&
        response.responseObject.length !== undefined) {
        this.pService.dataSource = response.responseObject;
        this.paginationSub = this.pService.dealers$.subscribe(result => {
          this.competenceListViewModel = this.competenceDataMapper(result);
        });
        this.total$ = this.pService.total$;
        this.spinner.hide();
      }
      else if(response.responseObject && response.responseObject.errorCount > 0)
      {
        if (response.responseObject.result &&
          response.responseObject.result.errorCode === Enums.ErrorCodes.CompetenceCode) {
          this.spinner.hide();
      }
      }
      this.spinner.hide();
    });
  }

  private competenceDataMapper(competence: any) {
    let supperArray = [];
    if (competence && competence.length > 0) {

      for (let index = 0; index < competence.length; index++) {
        const element = competence[index];

        let single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id=element.id;
        single.name= element.name;
        single.code= element.code;
        single.priority= element.priority == 0 ? '' : element.priority;
        single.brands= element.brands;
        single.isActive= element.isActive;
        single.isDefault= element.isDefault;
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  deleteCompetence(id: number) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblCompetence"),false);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => { 
      // This is intentional
    }, (reason) => {
      this.popupCloseResult = this.getDismissReason(reason);
      if (this.popupCloseResult) {
        this.competenceService.deleteCompetence(id).then((response) => {
          if (response.responseCode == Constant.SuccessResponseCode) {
            let successMsg = this.translate.instant("lblDeletedCompetence");
            this.toastr.success(successMsg)
            this.getCompetence((this.selectedStatus)?this.selectedStatus:0);
          }
        });
      }
    });
  }

  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }



  /**
* Methid to generate auto row number based on per page size
* @param cIndex
*/
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }
    return rtPageNumber;
  }

  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }

}
